import { View, Text } from "@gluestack-ui/themed";
import { Camera } from "@repo/core/components/core/Camera";
import Spinner from "@repo/core/components/core/Spinner";
import { HeaderStyleEnum } from "@repo/core/components/layout/CustomHeader/types";
import Scaffolds from "@repo/core/components/layout/Scaffolds";
import { StatusBarVariantEnum } from "@repo/core/components/layout/StatusBar/types";
import { OVERLAY_COLOR } from "@repo/core/screens/NewTransaction/NewTransactionQRCode/constants";
import { SCAN_SIZE } from "@repo/core/screens/NewTransaction/NewTransactionQRCode/constants";
import { NewTransactionQRCodeController } from "@repo/core/screens/NewTransaction/NewTransactionQRCode/controller";

const NewTransactionQRCode = () => {
  const { title, navigateBack, handleBarcodeScan, isLoading } =
    NewTransactionQRCodeController();

  return (
    <Scaffolds.Root
      flex={1}
      height="$100vh"
      position="relative"
      statusBarVariant={StatusBarVariantEnum.CAMERA}
      type={HeaderStyleEnum.transparent}
      title={title}
      onBackPress={navigateBack}
    >
      <View flex={1} position="absolute" top={0} left={0} right={0} bottom={0}>
        <Camera
          facing="back"
          onBarcodeScanned={handleBarcodeScan}
          isScanDisabled={isLoading}
        />
        {/* Container for all overlays */}
        <View position="absolute" top={0} left={0} right={0} bottom={0}>
          {/* Top section */}
          <View flex={3} backgroundColor={OVERLAY_COLOR} />

          {/* Middle section with scan window */}
          <View height={SCAN_SIZE} flexDirection="row">
            <View flex={1} backgroundColor={OVERLAY_COLOR} />
            <View width={SCAN_SIZE}>
              {/* Just the border for scanning frame */}
              <View
                position="absolute"
                top={0}
                left={0}
                right={0}
                bottom={0}
                borderWidth={2}
                shadowColor="$white"
                borderColor="$white"
              />
            </View>
            <View flex={1} backgroundColor={OVERLAY_COLOR} />
          </View>

          {/* Bottom section */}
          <View
            flex={4}
            backgroundColor={OVERLAY_COLOR}
            alignItems="center"
            gap="$2"
          >
            <Text
              color="$white"
              textAlign="center"
              maxWidth="50%"
              fontSize="$sm"
              marginTop="$4"
            >
              Aponte a câmera para o QR code gerado pelo cliente.
            </Text>
            {isLoading && <Spinner />}
          </View>
        </View>
      </View>
    </Scaffolds.Root>
  );
};

export default NewTransactionQRCode;
